export const environment = {
  production: false,
  apiUrl: '/api/v2/',
  translationPrefix: "",
  supportedLanguages: ['en', 'de', 'fr', 'it'],
  defaultLanguage: 'en',
  isDesktop: window["IsDesktop"],
  log: {
    missingTranslations: true,
    requestedTranslations: false  
  }
};
